import React, { useState } from "react";
import dayjs from "dayjs";
import DatePicker from '../../components/Picker/DatePicker';
import { useLanguage } from "../../hooks/useLanguage";

function MyOrderTerm({ onDateChange }) {
  const { t } = useLanguage();
  const [sdate, setSdate] = useState(null);
  const [edate, setEdate] = useState(null);

  const periodBtn = [
    { name: t('today'), id: '1', number: 1, type: 'today' },
    { name: t('1month'), id: '2', number: 1, type: 'month' },
    { name: t('3months'), id: '3', number: 3, type: 'month' },
    { name: t('6months'), id: '4', number: 6, type: 'month' },
    { name: t('1year'), id: '5', number: 1, type: 'year' },
  ];

  const handlePeriodClick = (number, type) => {
    const now = dayjs();
    if (type === 'today') {
      setSdate(now);
      setEdate(now);
    } else {
      setEdate(now);
      setSdate(now.subtract(number, type));
    }
    // 기간 버튼 클릭 시에는 자동으로 조회하지 않음
  };

  const handleSdateChange = (newDate) => {
    setSdate(newDate);
    // 날짜 변경 시에는 자동으로 조회하지 않음
  };

  const handleEdateChange = (newDate) => {
    setEdate(newDate);
    // 날짜 변경 시에는 자동으로 조회하지 않음
  };

  const handleSubmit = () => {
    // 조회 버튼 클릭 시에만 상위 컴포넌트로 날짜 전달
    if (sdate && edate && onDateChange) {
      onDateChange({
        sdate: sdate.format('YYYY-MM-DD'),
        edate: edate.format('YYYY-MM-DD')
      });
    }
  };

  return (
    <div>
      <div className="search_date_box">
        <div className="period_btn">
          {periodBtn.map((btn, idx) => (
            <button
              key={btn.id}
              type="button"
              className="default_btn xs white"
              onClick={() => handlePeriodClick(btn.number, btn.type)}
            >
              {btn.name}
            </button>
          ))}
        </div>

        <div className="select_date flex-center-4">
          <div className="datepicker_wrapper">
            <DatePicker
              value={sdate}
              onDateChange={handleSdateChange}
              placeholder="0000.00.00"
              inputClassName="datepicker_input"
            />
          </div>

          <div className="datepicker_wrapper">
            <DatePicker
              value={edate}
              onDateChange={handleEdateChange}
              placeholder="0000.00.00"
              inputClassName="datepicker_input"
            />
          </div>

          <button type="button" className="default_btn sm black" onClick={handleSubmit}>
            {t('search')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default MyOrderTerm;
